import { useContext } from 'react';
import Navbar from "./navbar";
import NavbarPublic from "./navbarPublic";
import { AuthContext } from "../context/authContext";
import { useTheme } from "../context/ThemeContext";

const ThemeButton = () => {
    const { isDarkMode, toggleTheme } = useTheme();
    
    return (
        <div className='border rounded-lg overflow-hidden'>
            <button
                onClick={toggleTheme}
                className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                aria-label={`Cambiar a modo ${isDarkMode ? 'claro' : 'oscuro'}`}
            >
                {isDarkMode ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707" />
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                    </svg>
                )}
            </button>
        </div>
    );
};

const Header = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);

    return (       
        <header className="flex flex-col md:flex-row gap-y-4 justify-center items-center bg-gradient-to-r from-[#e81f76] via-[#417099] to-[#00AEC3] dark:from-gray-800 dark:via-gray-700 dark:to-gray-800">
            <div className="flex justify-between items-center px-4 w-full">
                {isAuthenticated ? <Navbar /> : <NavbarPublic />}
                {/* <ThemeButton /> */}
            </div>
        </header>
    );
};

export default Header;

// quitar 
// <header className="w-full bg-custom-cyan dark:bg-gray-800 shadow-sm transition-colors duration-300 border-yellow-500">
// excedia el ancho de pantalla